export const FIXRECORD_LIST_REQUEST = 'FIXRECORD_LIST_REQUEST';
export const FIXRECORD_LIST_SUCCESS = 'FIXRECORD_LIST_SUCCESS';
export const FIXRECORD_LIST_FAILURE = 'FIXRECORD_LIST_FAILURE';
export const FIXRECORD_ADD_REQUEST = 'FIXRECORD_ADD_REQUEST';
export const FIXRECORD_ADD_SUCCESS = 'FIXRECORD_ADD_SUCCESS';
export const FIXRECORD_ADD_FAILURE = 'FIXRECORD_ADD_FAILURE';
export const FIXRECORD_DELETE_REQUEST = 'FIXRECORD_DELETE_REQUEST';
export const FIXRECORD_DELETE_SUCCESS = 'FIXRECORD_DELETE_SUCCESS';
export const FIXRECORD_DELETE_FAILURE = 'FIXRECORD_DELETE_FAILURE';

export const fixrecordListRequest = (station, page, per_page) => {
    return {
        type: FIXRECORD_LIST_REQUEST,
        station: station,
        page: page,
        per_page: per_page
    }
}

export const fixrecordListSuccess = (result) => {
    return {
        type: FIXRECORD_LIST_SUCCESS,
        ...result,
    }
}

export const fixrecordListFailure = (error) => {
    return {
        type: FIXRECORD_LIST_FAILURE,
        error,
    }
}

export const fixrecordAddRequest = (data) => {
    return {
        type: FIXRECORD_ADD_REQUEST,
        data: data
    }
}

export const fixrecordAddSuccess = (result) => {
    return {
        type: FIXRECORD_ADD_SUCCESS,
        ...result
    }
}

export const fixrecordAddFailure = (error) => {
    return {
        type: FIXRECORD_ADD_FAILURE,
        error,
    }
}

export const fixrecordDeleteRequest = (station, id, page, per_page) => {
    return {
        type: FIXRECORD_DELETE_REQUEST,
        station: station,
        id: id,
        page: page,
        per_page: per_page
    }
}

export const fixrecordDeleteSuccess = (result) => {
    return {
        type: FIXRECORD_DELETE_SUCCESS,
        ...result
    }
}

export const fixrecordDeleteFailure = (error) => {
    return {
        type: FIXRECORD_DELETE_FAILURE,
        error,
    }
}